// actionTypes.js
// surveyReportAction types
export const FETCH_SURVEYS_WITH_DETAILS_REQUEST = 'FETCH_SURVEYS_WITH_DETAILS_REQUEST'
export const FETCH_SURVEYS_WITH_DETAILS_SUCCESS = 'FETCH_SURVEYS_WITH_DETAILS_SUCCESS'
export const FETCH_SURVEYS_WITH_DETAILS_FAILURE = 'FETCH_SURVEYS_WITH_DETAILS_FAILURE'
